export function defineCookie(_category: string): void {
	return;
}
